import {USER_TYPE} from '../actions/types';

const INITIAL_STATE = {
  token: null,
  firsttime1: true,
  firsttime2: true,
  firsttime3: true,
  firsttime: false,
  userStatus: null,
  mobile: null,
  notshow: false,
  info: null,
  wallet_credit: 0,
  keyboardHeight: 0,
  deposit_credit: 0,
  BirthDate: null,
  idcart: null,
  notiftoken: null,
  pwaalarm: true,
  notificationmodal: false,
  active: false,
  vrnmodal: true,
  vrnmodaltype: null,
  enseraf: false,
  debtor_trip: false,
  isFirstOpen: true,
  isLearnNotifVisible: false,
  isLearnToastVisible: true,
  endTripImageIds: [],
  city: null,
  needUploadImage: true,
  gender: false,
  allowedToRideVehicles: [],
};

const User = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case USER_TYPE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default User;
